<template>
  <div class="register absolute">
    <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
        <img :src="logoUrl" v-if="logoUrl" />
        <img src="@assets/logo.png" v-else />
      </div>
    </div>
    <div class="whiteBg">
      <div class="title">注册批发商账号</div>
      <div class="list">
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="captcha"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
              type="password"
              placeholder="填写您的登录密码"
              v-model="password"
            />
          </div>
        </div>
        <div class="item" v-if="isShowCode">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="codeVal"
            />
            <div class="code" @click="again"><img :src="codeUrl" /></div>
          </div>
        </div>
        <div class="uploadBox">
            <div>
                <div style="margin: 0.2rem 0;">上传营业执照</div>
                <div v-if="!file1" class="addImg" @click="choseImg1">+</div>
                <img v-else class="uploadImg" :src="file1" alt="">
            </div>
            <div>
                <div style="margin: 0.2rem 0;">上传身份证</div>
                <div v-if="!file2" class="addImg" @click="choseImg2">+</div>
                <img v-else class="uploadImg" :src="file2" alt="">
            </div>
        </div>
        <input type="file" style="display: none;" ref="file1" @change="file1Change">
        <input type="file" style="display: none;" ref="file2" @change="file2Change">
      </div>
      <div class="logon" @click="register">注册</div>
      <div class="tip">
        已有账号?
        <span @click="toBeWholesaler" class="font-color-red">立即登录</span>
      </div>
    </div>
    <div class="bottom"></div>
  </div>
</template>
<script>
var _mine
import sendVerifyCode from "@mixins/SendVerifyCode";
import {
  login,
  loginMobile,
  registerVerify,
  register,
  getCodeApi
} from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getLogo, uploadImg } from "@api/public";
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL } from "@utils";
import { log } from 'util';

const BACK_URL = "login_back_url";

export default {
  name: "Login",
  mixins: [sendVerifyCode],
  data: function() {
    return {
      navList: ["账号登录", "快速登录"],
      current: 1,
      account: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      logoUrl: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false,
      // 营业执照
      file1: null,
      hasFile1: false,
      // 身份证
      file2: null,
      hasFile2: false
    };
  },
  mounted: function() {
    _mine = this
    this.getCode();
    this.getLogoImage();
  },
  methods: {
    choseImg1: function() {
        this.$refs.file1.click()
    },
    choseImg2: function(){
        this.$refs.file2.click()
    },
    file1Change: function(e) {
      const file = this.$refs.file1.files[0]
      const type = file.type.substring(0, 5)
      const size = file.size / 1024
      if (type != 'image') return this.$dialog.error('请选择图片上传');
      if(size >= 1024) return this.$dialog.error('请上传小于1MB的图片');
      let param = new FormData()  // 创建form对象
      param.append('file', file) 
      uploadImg(param).then(res => {
        console.log(res);
        const { url } = res.data.data
        _mine.file1 = url
      }).catch(err => {
        console.log(err);
      })
    },
    file2Change: function(e) {
      const file = this.$refs.file2.files[0]
      const type = file.type.substring(0, 5)
      const size = file.size / 1024
      if (type != 'image') return this.$dialog.error('请选择图片上传');
      if(size >= 1024) return this.$dialog.error('请上传小于1MB的图片');
      let param = new FormData()  // 创建form对象
      param.append('file', file) 
      uploadImg(param).then(res => {
        console.log(res);
        const { url } = res.data.data
        _mine.file2 = url
      }).catch(err => {
        console.log(err);
      })
    },
    again() {
      this.codeUrl =
        VUE_APP_API_URL +
        "/sms_captcha?" +
        "key=" +
        this.keyCode +
        Date.parse(new Date());
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    async getLogoImage() {
      let that = this;
      getLogo(2).then(res => {
        that.logoUrl = res.data.logo_url;
      });
    },
    async loginMobile() {
      var that = this;
      const { account, captcha } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({ account, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      loginMobile({
        phone: that.account,
        captcha: that.captcha,
        spread: cookie.get("spread")
      })
        .then(res => {
          let data = res.data;
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time
          };
          window.localStorage.setItem('token', data.token)
          that.$store.commit("LOGIN", data.token);
          // let newTime = Math.round(new Date() / 1000)
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          that.$router.replace({ path: backUrl });
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async register() {
      var that = this;
      const { account, captcha, password, file1, file2 } = that;
      if(!file1) return that.$dialog.error('营业执照照片不能为空');
      if(!file2) return that.$dialog.error('身份证照片不能为空');
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ],
            password: [
              required(required.message("密码")),
              attrs.range([6, 16], attrs.range.message("密码")),
              alpha_num(alpha_num.message("密码"))
            ]
          })
          .validate({ account, captcha, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      register({
        account: that.account,
        captcha: that.captcha,
        password: that.password,
        license: that.file1,
        card: that.file2,
        wholesale: 2,
        spread: cookie.get("spread")
      })
        .then(res => {
          that.$dialog.success(res.msg);
          if(res.status == 200){
            that.$router.push({name:'Login', params: {
              account: that.account,
              password: that.password
            }})
          }
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      await registerVerify({
        phone: that.account,
        type: "register",
        key: that.keyCode,
        code: that.codeVal
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          if (res.data.status === 402) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    },
    navTap: function(index) {
      this.current = index;
    },
    async submit() {
      const { account, password, codeVal } = this;
      try {
        await this.$validator({
          account: [
            required(required.message("账号")),
            attrs.range([5, 16], attrs.range.message("账号")),
            alpha_num(alpha_num.message("账号"))
          ],
          password: [
            required(required.message("密码")),
            attrs.range([6, 16], attrs.range.message("密码")),
            alpha_num(alpha_num.message("密码"))
          ],
          codeVal: this.isShowCode
            ? [
                required(required.message("验证码")),
                attrs.length(4, attrs.length.message("验证码")),
                alpha_num(alpha_num.message("验证码"))
              ]
            : []
        }).validate({ account, password, codeVal });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      login({ account, password, code: codeVal })
        .then(({ data }) => {
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time
          };
          console.log(data.token);
          window.localStorage.setItem('token', data.token) 
          this.$store.commit("LOGIN", data.token);
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          this.$router.replace({ path: backUrl, query: { login: 1} });
        })
        .catch(e => {
          this.$dialog.error(e.msg);
        });
    },
    toBeWholesaler: function () {
        this.$router.push('/login')
    }
  }
};
</script>
<style scoped>
.code img {
  width: 100%;
  height: 100%;
}
.uploadBox{
  display: flex;
  justify-content: space-between;
  margin: 0.1rem 0;
  text-align: center;
}
.addImg{
    width: 2.5rem;
    height: 2.5rem;
    border: 1px dashed #ccc;
    border-radius: 5px;
    font-size: 0.75rem;
    line-height: 2.5rem;
    text-align: center;
    box-sizing: border-box;
}
.uploadImg{
  width: 2.5rem;
  height: 2.5rem;
  box-sizing: border-box;
}
</style>
